<template>
    <div class="page">

        <div class="page__header">
            <div class="page__info">
                <div class="page__title">Списания</div>
                <div class="page__desc">Список списаний</div>
            </div>
        </div>

        <div class="page__content">
            <div class="table-responsive">
                <table class="table table-striped">
                    <tr>
                        <th>Поставка</th>
                        <th>Магазин</th>
                        <th>Продукт</th>
                        <th>Количество</th>
                        <th>Причина</th>
                        <!--<th>Срок годности</th>-->
                        <th>Дата поставки</th>
                        <th></th>
                    </tr>
                    <tr v-for="writeOff in writeOffs" v-bind:key="writeOff.id">
                        <td>
                            <router-link
                                    :to="{ name: 'StoreSuppliesUpdate', params: {id: writeOff.supply_id } }">#{{ writeOff.supply_id }}</router-link>
                        </td>
                        <td>{{ stores[writeOff.store_id].address }}</td>
                        <td>{{ products[writeOff.product_id].title }}</td>
                        <td>{{ writeOff.quantity }} {{ products[writeOff.product_id].packaging_type }}</td>
                        <td>{{ writeOff.cause }}</td>
                        <!--<td><abbr :title="writeOff.expired_at | moment('DD MMM YYYY HH:mm')">{{ writeOff.expired_at | moment("DD MMM YYYY") }}</abbr></td>-->
                        <td><abbr :title="writeOff.created_at | moment('DD MMM YYYY HH:mm')">{{ writeOff.created_at | moment("DD MMM YYYY") }}</abbr></td>
                        <td>
                            <router-link
                                    :to="{ name: 'StoreWriteOffsUpdate', params: {id: writeOff.id } }"
                                    tag="input"
                                    type="button"
                                    class="btn btn-sm btn-warning"
                                    value="Изменить"/>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

    </div>
</template>


<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'StoreWriteOffs',
        computed: {
            writeOffs() {
                return this.$store.state.writeOffs.writeOffs.writeOffs
            },
            stores() {
                return this.$store.state.writeOffs.writeOffs.stores
            },
            products() {
                return this.$store.state.writeOffs.writeOffs.products
            }
        },
        methods: {
            ...mapActions([
                'storeWriteOffs'
            ]),
            async getWriteOffs() {
                await this.storeWriteOffs()
            }
        },
        created() {
            this.getWriteOffs();
        }
    }
</script>

<style lang="scss" scoped>
    .btn {
        margin-right: 10px;
    }
</style>